module.exports = __webpack_public_path__ + "static/media/16-d-calendar.5750f9ae.jpg";